import { render } from "./ReinitialisationMdp.vue?vue&type=template&id=ddf6a4f0"
import script from "./ReinitialisationMdp.vue?vue&type=script&lang=js"
export * from "./ReinitialisationMdp.vue?vue&type=script&lang=js"

import "./ReinitialisationMdp.vue?vue&type=style&index=0&id=ddf6a4f0&lang=scss"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__